export const golfMemberBenefits = [
  'Full use of Tanglewood Resort --including golf course, indoor and outdoor swimming pools, fitness center, health improvement classes (yoga, water aerobics, pilates), pickleball courts, fire pits, e-bikes. Monthly charging privileges.',
  '15% off discount on food and alcohol',
  'Exclusive member-only weekly buffet',
  '50% off hotel rooms year-round, excluding blackout dates (June & July)',
  'Three guests per member, member must be present to bring Guest',
  'Discounts on tickets to events',
  'Access to quarterly members only events',
  '20% off golf tee times for up to three accompanied guests',
  'Exclusive invitation to the Men’s and Women’s Club Championship Tournament',
  'Covered cart storage available for an additional fee'
]

export const socialMemberBenefits = [
  "Full use of Tanglewood Resort --including indoor and outdoor swimming pools, fitness center, health improvement classes (yoga, water aerobics, pilates), pickleball courts, fire pits, e-bikes",
  "20% off golf tee times, applies to member only",
  "Monthly charging privileges",
  "15% off discount on food and alcohol",
  "Exclusive member-only weekly buffet",
  "50% off hotel rooms year round, excluding blackout dates (June & July)",
  "Three guests per member, member must be present to bring Guest",
  "Discounts on tickets to events",
  "Access to quarterly members only events"
]

export const currentPricing = {
    'Golf': {
        priceId: process.env.REACT_APP_PRICE_GOLF || 'plan_ThBd7UkNlrbjll',
        displayName: 'Full Golf Membership - $500/month',
        endDate: '12/31/2026',
        initiation_fee: '$3000 (one time)',
        amount: '$500/month'
    },
    'Social':{
        priceId: process.env.REACT_APP_PRICE_SOCIAL || 'plan_ThBrFHU2vgn614',
        displayName: 'Social Membership - $125/month',
        endDate: '12/31/2026',
        initiation_fee: '$1000 (one time)',
        amount: '$125/month'
    },
    'Golf_Addon': {
        priceId: process.env.REACT_APP_PRICE_GOLF_ADDON || 'plan_ThC7TO4PngMrL1',
        displayName: 'Golf Add-on Membership - $125/month',
        endDate: '12/31/2026',
        amount: '$125/month',
    },
    'Social_Addon': {
        priceId: process.env.REACT_APP_PRICE_SOCIAL_ADDON || 'plan_ThD0G45RLWw0w6',
        displayName: 'Social Add-on Membership - $35/month',
        endDate: '12/31/2026',
        amount: '$35/month'
    }

}